module.exports = __webpack_public_path__ + "static/media/lilly.227d5752.svg";